var map = {
	"./close-btn.webp": 1780,
	"./icon-caution.webp": 1781,
	"./icon-checked.webp": 1782,
	"./icon-contact-us.webp": 1783,
	"./icon-email.webp": 1784,
	"./icon-eye-close.webp": 1785,
	"./icon-eye-open.webp": 1786,
	"./icon-forget-phone.webp": 1787,
	"./icon-google.webp": 1788,
	"./icon-login-email.webp": 1789,
	"./icon-password.webp": 1790,
	"./icon-robot-select.webp": 1791,
	"./icon-robot-unselect.webp": 1792,
	"./icon-telegram.webp": 1793,
	"./icon-user.webp": 1794,
	"./login-bg.webp": 1795,
	"./reglogin-bg-bm.webp": 1796,
	"./reglogin-bg-cn.webp": 1797,
	"./reglogin-bg-id.webp": 1798,
	"./reglogin-bg.webp": 1799,
	"./reglogin-m-bg-bm.webp": 1800,
	"./reglogin-m-bg-cn.webp": 1801,
	"./reglogin-m-bg-id.webp": 1802,
	"./reglogin-m-bg.webp": 1803
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 119;